import { trackOutboundLink } from './google-analytics';

const faq = [
  {
    slug: 'where-buy',
    question: `Where can I buy Holiday <em>Scratchers</em>?`,
    answer: `Holiday Scratchers from the Virginia Lottery - games make a great gift, so <strong style="text-decoration:underline;"><a target="_blank" href="https://www.valottery.com/wheretoplay.aspx">find a retailer</a></strong> near you.`,
  },
  {
    slug: 'where-express',
    question: 'Where can I learn more about Lottery Express Vending Machine?',
    answer: `Holiday Scratchers from the Virginia Lottery - people all over Virginia are winning! <strong style="text-decoration:underline;"><a target="_blank" href="https://www.valottery.com/howtoplay.aspx">Click here</a></strong> to learn how to play through the Lottery Express Vending Machine.`,
  },
  {
    slug: 'what-policy',
    question: `What is the Virginia Lottery's policy on prizes remaining for <em>Scratchers</em>?`,
    answer: `We post detailed information about all of our Holiday <em>Scratcher</em> games (including top prizes remaining) on this website. It's the most current source, and it's updated daily. You can also contact us by <strong style="text-decoration:underline;"><a href="https://www.valottery.com/contactus.aspx" target="_blank">clicking here</a></strong>.<br/><br/>
      When both of the following events have occurred in any <em>Scratcher</em> game: <br/>
      1. The last instant win top prize has been claimed; </br>
      2. All second-chance top prize drawings, if any, have been held; the Virginia Lottery will: </br>
      a) notify all Lottery retailers and Customer Service Centers to stop selling the game immediately; </br>
      b) automatically block future orders via the Lottery's computer systems; </br>
      c) automatically update the website on the next calendar day that no top prizes remain. </br>
      If you don't see a particular <em>Scratcher</em> game listed, it's probably expired, and you won't be able to claim a prize from that game anymore.`,
  },
  {
    slug: 'how-old',
    question: 'How old you have to be to buy Lottery?',
    answer: `Players and participants are required to be at least 18 years old. <strong style="text-decoration:underline;"><a target="_blank" href="https://www.valottery.com/age.aspx">Click here</a></strong> for more information about our age verification process.`,
  },
  {
    slug: 'contact-questions',
    question: 'How do I contact the lottery if I have additional questions?',
    answer: `We want to provide you with the most comprehensive information about the Virginia Lottery, and we want to do so in a timely manner. If you cannot find the answers you seek on this site or <strong style="text-decoration:underline;"><a href="https://valottery.com" target="_blank">valottery.com</a></strong>, we encourage you to contact us at (804)692-7777. Additionally, you can complete the contact form <strong style="text-decoration:underline;"><a href="https://valottery.com/contactus.aspx" target="_blank">here</a></strong> to email us.`,
  },
]

export default faq;



/** WEBPACK FOOTER **
 ** ./src/faq.js
 **/